module.exports = __webpack_public_path__ + "static/media/immobile_assets.a4f9ffb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameOceanCleanup/immobile_assets.png
// module id = 2563
// module chunks = 0